const s = "af.activation", t = class t extends CustomEvent {
  constructor(e) {
    super(s, { detail: e, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let a = t;
export {
  s as EVENT_NAME,
  a as default
};
//# sourceMappingURL=ActivationEvent.js.map
